import React, {
  useState,
  useRef,
  useEffect,
  useCallback,
  useMemo,
} from "react";
import ListPageHeader from "../../utilities/ListPageHeader";
import FusePageCarded from "@fuse/core/FusePageCarded/FusePageCarded";
import AgGridTable from "../../utilities/AgGridTable";
import Cards from "./Card";
// import data from "./data";
import { useNavigate } from "react-router-dom";
import clsx from "clsx";
import { makeStyles } from "@mui/styles";
import {
  Box,
  Button,
  Card,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import PartOrderComment from "./PartOrderComment";
import ViewPDF from "./ViewPDF";
import FormPageHeader from "../../utilities/FormPageHeader";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import moment from "moment";
import { AgGridReact } from "ag-grid-react";
import { useTheme } from "@mui/material/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .new, & .assigned, & .placed, & .ab_received, & .invoiced, & .inprogress":
    {
      borderRadius: "20px",
      fontSize: "11px",
      textAlign: "center",
      height: "26px",
      lineHeight: "26px",
      padding: "0px 10px",
      marginTop: "6px",
      color: theme.palette.common.white,
    },
    "& .new": {
      backgroundColor: theme.palette.info.main,
    },
    "& .assigned": {
      backgroundColor: theme.palette.warning.main,
    },
    "& .placed": {
      backgroundColor: theme.palette.grey[500],
    },
    "& .ab_received": {
      backgroundColor: theme.palette.success.main,
    },
    "& .invoiced": {
      backgroundColor: theme.palette.success.main,
    },
    "& .inprogress": {
      backgroundColor: theme.palette.success.main,
    },
  },
}));

const handleDateFormat = (props) => {
  return props.value && moment(props.value).format("DD-MM-YYYY");
};
var filterParams = {
  comparator: (filterLocalDateAtMidnight, cellValue) => {
    var dateAsString = cellValue;
    //Convert function date format from "2024-02-23T17:16:43.974" to 23/02/2024
    const date = new Date(dateAsString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const formattedDate = `${day}/${month}/${year}`;
    if (formattedDate == null) return -1;
    var dateParts = formattedDate.split("/");
    var cellDate = new Date(
      Number(dateParts[2]),
      Number(dateParts[1]) - 1,
      Number(dateParts[0]),
    );
    if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
      return 0;
    }
    if (cellDate < filterLocalDateAtMidnight) {
      return -1;
    }
    if (cellDate > filterLocalDateAtMidnight) {
      return 1;
    }
    return 0;
  },
  maxValidYear: new Date().getFullYear(),
};
const UnConfirmedOrders = (props) => {
  const classes = useStyles(props);
  const navigate = useNavigate();
  const theme = useTheme();
  const [rowData, setRowData] = useState([]);
  const gridRef = useRef();
  const [error, setError] = useState();
  const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.unconfimedOrderCriteria}`;
  const [showPaginationDropdown, setShowPaginationDropdown] = useState(false);
  const [gridApi, setGridApi] = useState(null);
  const [stateData, setStateData] = useState({
    filter: "",
    columnState: "",
    columnGroupState: "",
  });
  const stateRef = useRef();
  const saveGridStateName = "unConfirmedOrdersList";
  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      filter: true,
      floatingFilter: true,
      resizable: true,
      editable: true,
      filter: "agMultiColumnFilter",
      filterParams: {
        filters: [
          {
            filter: "agTextColumnFilter",
            filterParams: { buttons: ["clear"] },
          },
          {
            filter: "agSetColumnFilter",
            filterParams: {
              defaultToNothingSelected: true,
              buttons: ["clear"],
            },
          },
        ],
      },
    };
  }, []);
  const gridStyle = useMemo(
    () => ({ height: "calc(100% - 22.2px)", width: "100%" }),
    [],
  );
  const onGridReady = useCallback((params) => {
    setGridApi(params.api);
  }, []);

  const [columnDefs, setColumnDefs] = useState([
    {
      headerName: "Sr No.",
      minWidth: 60,
      maxWidth: 60,
      field: "srNo",
      pinned: "left",
      filter: false,
      resizable: true,
      valueGetter: (params) => params.node.rowIndex + 1,
    },

    {
      field: "abNumber",
      headerName: "AB Number",
      minWidth: 50,
      enableRowGroup: true,
    },
    {
      field: "commissionName",
      headerName: "Commission Name",
      minWidth: 50,
      enableRowGroup: true,
      minWidth: 250,
    },
    {
      field: "orderStatus",
      headerName: "Order Status",
      minWidth: 50,
      enableRowGroup: true,
    },
    {
      field: "vendorName",
      headerName: "Product",
      minWidth: 50,
      enableRowGroup: true,
    },
    {
      field: "orderCategory",
      headerName: "Category",
      minWidth: 50,
      enableRowGroup: true,
    },
    {
      field: "customerName",
      headerName: "Customer",
      minWidth: 50,
      enableRowGroup: true,
    },
    {
      field: "country",
      headerName: "Country",
      minWidth: 50,
      enableRowGroup: true,
    },
    {
      field: "volume",
      headerName: "Volume",
      minWidth: 50,
      enableRowGroup: true,
      filterParams: {
        filters: [
          {
            filter: "agNumberColumnFilter",
            filterParams: { buttons: ["clear"] },
          },
          {
            filter: "agSetColumnFilter",
            filterParams: {
              defaultToNothingSelected: true,
              buttons: ["clear"],
            },
          },
        ],
      },
    },
    {
      field: "weight",
      headerName: "Weight",
      minWidth: 50,
      enableRowGroup: true,
      filterParams: {
        filters: [
          {
            filter: "agNumberColumnFilter",
            filterParams: { buttons: ["clear"] },
          },
          {
            filter: "agSetColumnFilter",
            filterParams: {
              defaultToNothingSelected: true,
              buttons: ["clear"],
            },
          },
        ],
      },
    },
    {
      field: "revisedLpWg1",
      enableRowGroup: true,
      minWidth: 50,
      headerName: "LP WG1",
      filterParams: {
        filters: [
          {
            filter: "agNumberColumnFilter",
            filterParams: { buttons: ["clear"] },
          },
          {
            filter: "agSetColumnFilter",
            filterParams: {
              defaultToNothingSelected: true,
              buttons: ["clear"],
            },
          },
        ],
      },
    },
    {
      field: "revisedLpWg2",
      enableRowGroup: true,
      minWidth: 50,
      headerName: "LP WG2",
      filterParams: {
        filters: [
          {
            filter: "agNumberColumnFilter",
            filterParams: { buttons: ["clear"] },
          },
          {
            filter: "agSetColumnFilter",
            filterParams: {
              defaultToNothingSelected: true,
              buttons: ["clear"],
            },
          },
        ],
      },
    },
    {
      field: "totalRevisedLpWg1Wg2",
      enableRowGroup: true,
      minWidth: 50,
      headerName: "Total LP",
      filterParams: {
        filters: [
          {
            filter: "agNumberColumnFilter",
            filterParams: { buttons: ["clear"] },
          },
          {
            filter: "agSetColumnFilter",
            filterParams: {
              defaultToNothingSelected: true,
              buttons: ["clear"],
            },
          },
        ],
      },
    },
    {
      field: "caniasDocNum",
      enableRowGroup: true,
      minWidth: 50,
      headerName: "Canias Doc Num",
    },
    {
      field: "documentType",
      minWidth: 50,
      enableRowGroup: true,
      headerName: "Doc Type",
    },
    {
      field: "createdDate",
      enableRowGroup: true,
      minWidth: 50,
      headerName: "Created",
      filter: "agDateColumnFilter",
      filterParams,
      cellRenderer: handleDateFormat,
      sort: "desc",
    },
  ]);
  const handleDefaultGridState = () => {
    gridRef.current.api.setFilterModel(null);
    gridRef.current.columnApi.resetColumnState();
  };

  useEffect(() => {
    if (saveGridStateName) {
      stateRef.current = {
        screenName: saveGridStateName,
        screenState: stateData,
      };
    }
  }, [stateData]);

  const onFirstDataRendered = (params) => {
    const savedState = localStorage.getItem(`gridState-${saveGridStateName}`);
    if (savedState) {
      try {
        const data = JSON.parse(savedState);
        if (data.screenState?.filter) {
          params.api.setFilterModel(data.screenState.filter);
        }
        if (data.screenState?.columnState) {
          params.columnApi.applyColumnState({
            state: data.screenState.columnState,
            applyOrder: true,
          });
        }
        if (data.screenState?.columnGroupState) {
          params.columnApi.setColumnGroupState(
            data.screenState.columnGroupState,
          );
        }
      } catch (err) {
        console.error("Failed to load grid state:", err);
      }
    }
  };
  useEffect(() => {
    const unloadCallback = () => {
      if (saveGridStateName && stateRef.current) {
        localStorage.setItem(
          `gridState-${saveGridStateName}`,
          JSON.stringify(stateRef.current),
        );
      }
    };

    window.addEventListener("beforeunload", unloadCallback);
    return () => {
      window.removeEventListener("beforeunload", unloadCallback);
      unloadCallback();
    };
  }, []);

  const onFilterChanged = (params) => {
    stateData.filter = params.api.getFilterModel();
    setStateData({ ...stateData });
    if (!gridApi) return;
    gridApi.refreshCells({ columns: ["srNo"] });
  };

  const onColumnStateChanged = (params) => {
    stateData.columnState = params.columnApi.getColumnState();
    stateData.columnGroupState = params.columnApi.getColumnGroupState();
    setStateData({ ...stateData });
  };

  const onColumnGroupChange = (params) => {
    onColumnStateChanged(params);
  };

useEffect(() => {
  if (gridApi) {
    getPendingABList();
  }
}, [gridApi]);

  const getPendingABList = async () => {
   gridApi?.showLoadingOverlay();
    try {
      const result = await OAuthService.getList(url);
      setRowData(result.data._embedded?.orders);
    } catch (e) {
      console.log("error", e);
      setError(e.message);
      setRowData([]);
    }finally{
      gridApi?.hideOverlay();
    }
  };

  const onRowDoubleClicked = (params) => {
    var filename = params?.data?.id;

    navigate("/order/order-details/" + filename);
  };

  const onBtExport = useCallback(() => {
    const params = {
      fileName: "PendingABs.xlsx",
      sheetName: "Pending ABs",
    };
    gridRef.current.api.exportDataAsExcel(params);
  }, []);
  const handleBack = () => {
    navigate("/order/dashboard");
  };
  const orderHeaderAction = () => {
    // const navigate = useNavigate();
    return (
      <>
        <Tooltip title={"Back"}>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleBack}
            size="small"
            sx={{ minWidth: "auto" }}
          >
            <FuseSvgIcon size={18}>
              heroicons-solid:arrow-narrow-left
            </FuseSvgIcon>
          </Button>
        </Tooltip>
        <Tooltip title={"Export Unconfirmed Orders"}>
          <Button
            variant="contained"
            color="secondary"
            onClick={onBtExport}
            size="small"
            sx={{ minWidth: "auto" }}
          >
            <FuseSvgIcon size={18}>heroicons-solid:save</FuseSvgIcon>
          </Button>
        </Tooltip>
        <Tooltip title={"Default Grid State"}>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleDefaultGridState}
            size="small"
            sx={{ minWidth: "auto" }}
          >
            <FuseSvgIcon size={18}>material-outline:grid_on</FuseSvgIcon>
          </Button>
        </Tooltip>
      </>
    );
  };
  return (
    <>
      <FormPageHeader
        componentName="Unconfirmed Orders"
        pageName="Unconfirmed Orders"
        currentPage={"Unconfirmed Orders"}
        error={error}
        orderHeaderAction={orderHeaderAction()}
      ></FormPageHeader>
      <div
        className={clsx(classes.root, "h-full order-grid")}
        style={{ height: "100%", width: "100%" }}
      >
        <div
          style={gridStyle}
          className={`grid ${theme.palette.mode === "dark"
              ? "ag-theme-alpine-dark"
              : "ag-theme-alpine"
            }`}
        >
          <AgGridReact
            rowData={rowData}
            columnDefs={columnDefs}
            onGridReady={onGridReady}
            onFilterChanged={onFilterChanged}
            defaultColDef={defaultColDef}
            ref={gridRef}
            onRowDoubleClicked={onRowDoubleClicked}
            hideCheckbox={true}
            editable={false}
            rowHeight={22}
            headerHeight={30}
            cellSelection={true}
            suppressRowClickSelection={true}
            onFirstDataRendered={onFirstDataRendered}
            onColumnMoved={onColumnStateChanged}
            onColumnPinned={onColumnStateChanged}
            onColumnVisible={onColumnStateChanged}
            onColumnResized={onColumnStateChanged}
            onColumnRowGroupChanged={onColumnGroupChange}
            suppressDragLeaveHidesColumns={true}
            rowGroupPanelShow="always"
            groupDisplayType="multipleColumns"
            autoGroupColumnDef={{
              headerName: "Group",
              minWidth: 200,
              cellRendererParams: {
                suppressCount: false,
                checkbox: false,
              },
              pinned: "left",
            }}
          />
        </div>
      </div>
    </>
  );
};

export default UnConfirmedOrders;
